 <template>
  <div id="app">
    <div class="app-info">


      <div class="app-info-s">
        <div class="app-info-img">
          <img src="../../assets/img/app-abc@2x.png" alt srcset />
        </div>
        <div class="app-info-desc">
          <p>学习类-单词乐/学习乐</p>
          <br />
          <span>
            -伪装成背单词APP，积极向上的好学人设
            <br />-即时收到新聊天通知:提醒您背单词，安全即时
          </span>
          <br />
          <button @click="stu();upclick('btn_100010')">立即下载使用</button>

          <div class="app-info-right">免费下载</div>
        </div>
      </div>
      <div class="hyb_app_desc">
        <span>
          开发者：深圳市无间数码科技有限公司 应用名称：单词乐 
          <br />软件版本：V1.0.5 更新时间：2021-05-13
          <br />《<a style="text-decoration:underline" @click="goAppFunctionRight()">应用权限</a>》
                《<a style="text-decoration:underline" @click="goPrivacyAgree()">隐私协议</a>》
        </span>
      </div>

      <div class="app-info-s">
        <template v-if="isAndroid() === 1">
          <div class="app-info-img">
            <img src="../../assets/img/app-zhixuan@2x.png" alt srcset />
          </div>
        </template>
        <template v-if="isAndroid() === 0">
          <div class="app-info-img">
            <img src="../../assets/img/app-baike@2x.png" alt srcset />
          </div>
        </template>
        <div class="app-info-desc">
          <template v-if="isAndroid() === 1">
            <p>新闻类APP-天下事</p>
            <br />
            <span>
              -伪装成新闻类APP，神不知鬼不觉
              <br />-可以刷新实时新闻，完全仿真
            </span>
          </template>
          <template v-if="isAndroid() === 0">
            <p>百科类APP-今日百科</p>
            <br />
            <span>
              -伪装成工具类APP
              <br />-可以获取百科知识的工具，完全仿真
            </span>
          </template>
          <br />
          <button @click="toNews();upclick('btn_100009')">立即下载使用</button>
          <template v-if="isAndroid() === 1">
            <div class="app-info-right">VIP专属</div>
          </template>
          <template v-if="isAndroid() === 0">
            <div class="app-info-right">免费下载</div>
          </template>
        </div>
      </div>
      <div class="hyb_app_desc">
        <template v-if="isAndroid() === 1">
          <span>
            开发者：深圳市无间数码科技有限公司 应用名称：天下事 
            <br />软件版本：V2.1.1 更新时间：2021-05-14
            <br />《<a style="text-decoration:underline" @click="goAppFunctionRight()">应用权限</a>》
                 《<a style="text-decoration:underline" @click="goPrivacyAgree()">隐私协议</a>》
          </span>
         </template>
         <template v-if="isAndroid() === 0">
          <span>
            开发者：深圳市无间数码科技有限公司 应用名称：今日百科 
            <br />软件版本：V1.0.0 更新时间：2021-12-27
            <br />《<a style="text-decoration:underline" @click="goAppFunctionRight()">应用权限</a>》
                 《<a style="text-decoration:underline" @click="goPrivacyAgree()">隐私协议</a>》
          </span>
         </template>
      </div>

      <template v-if="isAndroid() === 1">
       <div class="app-info-s">
        <div class="app-info-img">
          <img src="../../assets/img/app-jisuanqi@2x.png" alt srcset />
        </div>
        <div class="app-info-desc">
          <p>工具类-计算器APP</p>
          <br />
          <span>
            -伪装成计算器等工具，人畜无害
            <br />-操作简便，适合所有人群
          </span>
          <br />
          <button @click="jisuan();upclick('btn_100008')">立即下载使用</button>

          <div class="app-info-right">免费下载</div>
        </div>
      </div>
       <div class="hyb_app_desc">
        <span>
          开发者：深圳市无间数码科技有限公司 应用名称：计算器 
          <br />软件版本：V2.1.1 更新时间：2021-05-14
          <br />《<a style="text-decoration:underline" @click="goAppFunctionRight()">应用权限</a>》
                《<a style="text-decoration:underline" @click="goPrivacyAgree()">隐私协议</a>》
        </span>
       </div>
      </template>
      <template v-if="isAndroid() === 0">
       <div class="app-info-s">
         <div class="app-info-img">
          <img src="../../assets/img/app-zhixuan@2x.png" alt srcset />
         </div>
         <div class="app-info-desc">
            <p>新闻类APP-天下事</p>
            <br />
            <span>
              -伪装成新闻类APP，神不知鬼不觉
              <br />-可以刷新实时新闻，完全仿真
            </span>
           <br />
            <button @click="toNewsIos();upclick('btn_100009')">立即下载使用</button>
           <div class="app-info-right">VIP专属</div>
         </div>
       </div> 
         <div class="hyb_app_desc">
          <span>
            开发者：深圳市无间数码科技有限公司 应用名称：天下事 
            <br />软件版本：V2.1.1 更新时间：2021-05-14
            <br />《<a style="text-decoration:underline" @click="goAppFunctionRight()">应用权限</a>》
                 《<a style="text-decoration:underline" @click="goPrivacyAgree()">隐私协议</a>》
          </span>
        </div>
      </template>

      

      <div class="app-foot">不同类型的APP之间可以正常交流</div>

        

  <!--默认浏览器 -->
     <div class="tan" :class="{tanhide:iostande}">
      <div class="tan-head">
        <img :src="closeSrc" @click="iosColseTande" />
      </div>
      <div class="tan-page">
        <p>亲爱的用户，请您使用苹果"Safari浏览器"打开好运吧官网【www.haoyunba.com】进行下载，谢谢！</p>
      </div>
      <div class="tan-foot"  v-clipboard:copy="url"
        v-clipboard:success="copy"
        v-clipboard:error="onError">
        <span>复制网址</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:iostande}"></div>


    </div>
  </div>
</template>
<script>
import tips from "@/estoast";
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      btnflag: false
    };
  },
  mounted() {
    console.log("cid:" + JSON.stringify(store.state.mutations.channel));

    //  if( store.state.mutations.channel == 'S00991'){
    //    this.btnflag = true
    //   }
  },
  methods: {
    upclick: function(tag) {
      this.$point.eventId(tag);
    },
    jisuan: function() {
      if (navigator.userAgent.indexOf("Android") > -1) {
        this.$router.push("/userAppInfo?token=" + this.getToken);
      }else{
        tips.toast("亲爱的用户:计算器ios版本暂时不可用，您可以先下载单词乐使用。");
      }
      
    },
 
    isAndroid(){
      if (navigator.userAgent.indexOf("Android") > -1) {
        //tips.toast("it is android");
        return 1;
      }else{
        //tips.toast("it is ios");
        return 0;
      }
    },
    stu() {
      console.log("aaaa")
      if (navigator.userAgent.indexOf("Android") > -1) {
        // tips.toast("即将上线，敬请期待");
        this.$point.eventId("down_app_study_100001");
        window.location = "http://wap.haoyunba.com/apk/study_android.apk";
      } else {
        window.location = "https://apps.apple.com/cn/app/id1567037244";
        //window.location = "http://www.xuexilevip.com/download.html";
        // tips.toast("亲爱的用户:学习乐ios版本正在更新中，您可以先下载计算器和天下事使用。");
        //Ios
        /*
          let ua = navigator.userAgent.toLowerCase();

          //tips.toast(" \n 即将上线，敬请期待");
          console.log("ios cid:" + store.state.mutations.channel);
          //非默认浏览器
          if (ua.indexOf("safari") > 0) {
            setTimeout(() => {
              this.$router.push("/iosSetting");
            }, 2000);

            var appurl =
              "itms-services:///?action=download-manifest&url=https://www.haoyunba.com/h5/ios/xxl/manifest.plist";

            window.location.href = appurl;
          } else {
            // this.iostande = false;
            tips.toast("亲爱的用户，请您使用苹果\"Safari浏览器\"打开好运吧官网【www.haoyunba.com】进行下载，谢谢！");
          }
          */
      }
    },
    shangxian: function() {
      tips.toast("即将上线，敬请期待");
    },
    toNews: function() {
      if (store.state.mutations.channel == "S00991") {
        tips.toast("即将上线，敬请期待");
        return;
      }
      /*
      var userInfo = this.getUserInfo;
      if (userInfo.viptype > 0) {
        //判断是否过期
        var nowtime = new Date();
        var validitydate = new Date(userInfo.validitydate);
        if (validitydate < nowtime) {
          tips.toast("您的会员已经过期");
          return;
        } else {
          if (navigator.userAgent.indexOf("Android") > -1) {
            // tips.toast("即将上线，敬请期待");
            this.$point.eventId("down_app_news_100001");
            window.location = "http://wap.haoyunba.com/apk/news_android.apk";
          } else {
            this.$router.push("/userAppInfotxs?token=" + this.getToken);
          }
        }
      } else {
        if (navigator.userAgent.indexOf("Android") > -1) {
          // tips.toast("即将上线，敬请期待");
          this.$point.eventId("down_app_news_100001");
          window.location = "http://wap.haoyunba.com/apk/news_android.apk";
        } else {
          tips.toast("该软件付费后即可使用，请先购买会员");
          setTimeout(() => {
            this.$router.push("/pay");
          }, 2000);
        }
        return;
      }
      */
     if (navigator.userAgent.indexOf("Android") > -1) {
            // tips.toast("即将上线，敬请期待");
            this.$point.eventId("down_app_news_100001");
            window.location = "http://wap.haoyunba.com/apk/news_android.apk";
          } else {
            
           //tips.toast("亲爱的用户:天下事ios版本暂时不可用，您可以先下载单词乐使用。");
           window.location = "https://apps.apple.com/cn/app/id1598592223";
          }
    },
    toNewsIos:function(){
      tips.toast("亲爱的用户:天下事ios版本暂时不可用，您可以先下载“单词乐”或“今日百科”使用。");
    },
    goPrivacyAgree: function() {
      this.$router.push("/agree/privacyAgree");
    },
    goAppFunctionRight: function() {
      this.$router.push("/agree/appFunctionRight");
    },
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
#app {
  width: 100%;
  height: auto;
}
.app-info {
  width: 100%;
  height: auto;
}
.app-info-s {
  width: 690px;
  height: 284px;
  background: #0a0f3d;
  opacity: 1;
  border-radius: 20px;
  padding-top: 40px;
  margin: 40px auto 0;
  display: flex;
}
.app-info-img {
  width: 182px;
  height: 200px;
  text-align: center;
}

.app-info-img img {
  width: 122px;
  height: 122px;
}

.app-info-desc {
  flex: 1;
  text-align: left;
}

.app-info-desc p {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 44px;
  color: #ffccb3;
  opacity: 1;
  padding: 0;
  margin: 0;
}

.app-info-desc span {
  font-size: 20px;
  font-family: PingFangSC-Regular;
  line-height: 28px;
  color: #99877a;
  opacity: 1;
}

.app-info-desc button {
  width: 240px;
  height: 48px;
  background: linear-gradient(90deg, #eeae91 0%, #f9dcc1 100%);
  border-radius: 24px;
  margin-top: 36px;
  border: none;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 48px;
}
.app-info-right {
  background-image: url("../../assets/img/app-info-right.png");
  position: relative;
  width: 108px;
  height: 30px;
  opacity: 1;
  top: -235px;
  right: -380px;
  background-size: 100%;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 30px;
  color: #ffccb3;
  opacity: 1;
  text-align: center;
}
.app-foot {
  width: 456px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular;
  line-height: 32px;
  color: #99877a;
  opacity: 1;
  margin: 40px auto 106px auto;
}
.hyb_app_desc{

  color: #99877a;
  font-size: 24px;
}
</style>
 
 
 


// WEBPACK FOOTER //
// src/components/common/downAppLists.vue